<template>
  <v-card elevation="0" class="mt-2" max-width="1000">
    <v-card-text>
      <p class="text-right caption">
        2018-10-14 21:30:09 이신희(shinhee)
      </p>
      <p class="text-h5 mb-5">★ 데브몬 회식일정</p>
      <div class="mb-8">
        금주 있을 데브몬 회식 일정에 대해 투표 부탁 드립니다.
      </div>
      <div>첨부파일</div>
    </v-card-text>
    <v-card-actions class="d-flex justify-center">
      <v-btn elevation="0" color="primary">수정</v-btn>
      <v-btn elevation="0" outlined color="primary" to="/notice/list">
        목록
      </v-btn>
      <v-btn elevation="0" outlined color="red">삭제</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {};
</script>

<style></style>
